import AppConfig from '@/config'
import { brandName } from '@/config/tenant'
import defaultMediaIcon from '@/resources/icons/docs/music.svg'
import mtsMediaIcon from '@/resources/icons/mts/music_mts.svg'

export type WelcomeVariant = 'default' | 'attached' | 'imageEdit' | 'search' | 'music' | 'song' | 'secret'

export const welcomeMediaIcon: string = AppConfig.isMts ? mtsMediaIcon : defaultMediaIcon

export const welcomeStrings = {
	defaultTitle: 'Начните новый диалог',
	defaultDescription: 'Задайте вопрос',
	attachedPrefix: 'Нажмите кнопку ',
	attachedDocsSuffix: ', чтобы загрузить документы. Обработка займет несколько секунд!',
	attachedImageSuffix: ', чтобы загрузить изображение. Обработка займет несколько секунд!',
	searchLine1: `Привет! Я ${brandName()} - помогу найти информацию по открытым источникам и сайтам.`,
	searchLine2: 'Могу быстро проверить факты, найти статьи или показать свежие новости.',
	music: 'Введите текстовое описание для генерации мелодии',
	song: 'Добавьте текст и выберите настройки создания песни',
	secret: 'Этот чат не сохранится в истории'
} as const
